import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Button, Stack } from '@mui/material';
import BasicDetailsCard from '../../../../components/common/BasicDetailsCard';
import {
	VendorApprovedsingle,
	VendorRequestGetsingle,
	VendorRequestPUTsingle,
} from '../../../../services/api/vendor';
import FixedBackButton from '../Vendor-ui/BackButton';
import MySnackbarModal from '../Vendor-ui/SnackbarModal';
import { MyModal } from '../Vendor-ui/Modal';
// ✅ Import your custom modal

export default function VendorRequestView() {
	const { id } = useParams();
	const [vendorData, setVendorData] = useState<any>(null);
	const [loading, setLoading] = useState(true);
	const [updating, setUpdating] = useState(false);
	const [loader, setLoader] = useState(false);

	// Modal & snackbar states
	const [modalOpen, setModalOpen] = useState(false);
	const [modalAction, setModalAction] = useState<'approve' | 'reject' | null>(null);
	const [snackbarOpen, setSnackbarOpen] = useState(false);
	const [snackbarAction, setSnackbarAction] = useState<'approve' | 'reject' | null>(null);
	const [snackbarMessage, setSnackbarMessage] = useState('');

	// Fetch vendor data
	const fetchData = async () => {
		setLoading(true);
		try {
			const response = await VendorRequestGetsingle(id);
			if (response?.success) {
				setVendorData(response.data.vendor);
			}
		} catch (error) {
			console.error('Error fetching vendor details:', error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchData();
	}, [id]);

	// Open modal with action
	const handleOpenModal = (type: 'approve' | 'reject') => {
		setModalAction(type);
		setModalOpen(true);
	};

	// Handle approval/rejection
	const handleApprovalAction = async (action: 'approve' | 'reject', reason?: string) => {
		if (!vendorData) return;
		setUpdating(true);

		try {
			setLoader(true);
			let response;
			if (action === 'approve') {
				const payload = {
					status: 'Approved',
					reason: 'string', // ✅ optional reason captured from modal
				};
				response = await VendorApprovedsingle(id, payload);
			} else {
				// rejected → update vendor status
				const payload = {
					...vendorData,
					status: 'Rejected',
					reason, // ✅ optional reason captured from modal
				};
				response = await VendorApprovedsingle(id, payload);
			}

			console.log(response);
			if (response?.success) {
				setSnackbarAction('approve');
				setSnackbarMessage(response?.data?.message);
				setSnackbarOpen(true);
				fetchData();
				window.location.href = '/vendor/approved';
			} else {
				setSnackbarAction('reject');
				setSnackbarMessage(response?.data?.errors || 'Failed to update.');
				setSnackbarOpen(true);
			}
		} catch (error) {
			console.error(`Error updating vendor status:`, error);
			setSnackbarAction(action);
			setSnackbarMessage('Something went wrong.');
			setSnackbarOpen(true);
		} finally {
			setUpdating(false);
			setModalOpen(false);
			setLoader(false);
		}
	};

	// Handle vendor detail update (Submit button)
	const handleSubmit = async () => {
		if (!vendorData) return;
		setUpdating(true);

		try {
			const res = await VendorRequestPUTsingle(id, { ...vendorData });

			if (res?.success) {
				setSnackbarAction('approve');
				setSnackbarMessage('Vendor details updated successfully.');
				setSnackbarOpen(true);
				fetchData();
			} else {
				setSnackbarAction(null);
				setSnackbarMessage('Failed to update vendor details.');
				setSnackbarOpen(true);
			}
		} catch (error) {
			console.error('Error submitting vendor data:', error);
			setSnackbarMessage('Something went wrong.');
			setSnackbarOpen(true);
		} finally {
			setUpdating(false);
		}
	};

	if (loading) {
		return (
			<Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
				<CircularProgress />
			</Box>
		);
	}

	if (!vendorData) {
		return <Box sx={{ textAlign: 'center', mt: 4 }}>Vendor not found.</Box>;
	}

	return (
		<>
			<Box sx={{ height: '80vh', overflowY: 'auto' }}>
				<Box>
					<FixedBackButton />
				</Box>
				<Box sx={{ pt: 5 }}>
					<BasicDetailsCard vendor={vendorData} />
				</Box>

				{/* Permissions Table */}
				{/* <Box sx={{ mt: 2 }}>
					<MenuTable
						permissions={vendorData.permissions}
						onChange={(updatedPermissions) =>
							setVendorData((prev: any) => ({
								...prev,
								permissions: updatedPermissions,
							}))
						}
					/>
				</Box> */}

				{/* Action Buttons */}
				<Box
					sx={{
						position: 'fixed',
						bottom: 0,
						left: 65,
						right: 0,
						bgcolor: 'background.paper',
						boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
						p: 1,
						zIndex: 1300,
					}}
				>
					<Stack direction="row" spacing={2} justifyContent="end">
						<Button
							variant="contained"
							color="success"
							onClick={() => handleOpenModal('approve')}
							disabled={updating}
						>
							Approve
						</Button>
						{(!vendorData.approvelStatus as any) === 'Rejected' && (
							<Button
								variant="contained"
								color="error"
								onClick={() => handleOpenModal('reject')}
								disabled={updating}
							>
								Reject
							</Button>
						)}
						<Button
							variant="contained"
							color="primary"
							onClick={handleSubmit}
							disabled={updating}
						>
							Submit
						</Button>
					</Stack>
				</Box>
			</Box>

			{/* ✅ Custom Modal instead of Dialog */}
			<MyModal
				loader={loader}
				open={modalOpen}
				action={modalAction}
				request={'request'}
				onClose={() => setModalOpen(false)}
				onConfirm={(reason?: string) => handleApprovalAction(modalAction!, reason)}
			/>

			{/* Snackbar modal for success/error */}
			<MySnackbarModal
				open={snackbarOpen}
				action={snackbarAction}
				Message={snackbarMessage}
				onClose={() => setSnackbarOpen(false)}
				loading={updating}
			/>
		</>
	);
}
